import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisRoleToContextsWrapper } from '@adornis/users/db/roleToContextsWrapper.js';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';

@Entity()
export class DynamicAdornisRoleToContextsWrapper extends AdornisRoleToContextsWrapper {
  static override _class = 'DynamicAdornisRoleToContextsWrapper';

  @validate(nonOptional())
  @Field(type => Boolean, { default: v => true })
  isDynamic!: boolean;
}
